import { render, staticRenderFns } from "./ChangeOrderList.vue?vue&type=template&id=853893f8&scoped=true"
import script from "./ChangeOrderList.vue?vue&type=script&lang=js"
export * from "./ChangeOrderList.vue?vue&type=script&lang=js"
import style0 from "./ChangeOrderList.vue?vue&type=style&index=0&id=853893f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853893f8",
  null
  
)

export default component.exports